<template>
  <!-- 对话框 -->
  <el-drawer title="添加司机信息" :visible.sync="show" :with-header="false" :before-close="closeDialog"  size="600px" destroy-on-close append-to-body>

    <!-- 基本信息表单 -->
    <div class="form-box edit-driver">


      <template>
        <el-tabs v-model="activeName" class="tabs">

          <el-tab-pane label="基础信息" name="first">


            <basicsAssembly :driverShow="show" :data="data" @closeDialog="closeDialog"></basicsAssembly>

          </el-tab-pane>

          <el-tab-pane label="审核信息" name="second">


            <!-- 审核详情组件 -->
            <examineAssembly :driverShow="show" :data="data" @closeDialog="closeDialog"></examineAssembly>

          </el-tab-pane>

          <el-tab-pane label="账面分" name="third" v-if="driver_driverpoints_add == '1'">


            <!-- 分数详情组件 -->
            <driverFraction :driverShow="show" :data="data" @closeDialog="closeDialog"></driverFraction>

          </el-tab-pane>

        </el-tabs>

      </template>


    </div>

  </el-drawer>
</template>

<script>
  var _this;
  // 基础信息
  import basicsAssembly from './basicsAssembly.vue';
  // 审核信息详情
  import examineAssembly from './examineAssembly.vue';
  // 分数详情组件
  import driverFraction from './driverFraction.vue';
  import bus from '../../common/bus.js';
  export default {
    props: {
      'isShow': Boolean,
      'data': '',

    },
    components: {
      basicsAssembly,
      examineAssembly,
      driverFraction
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;


      },

    },
    data() {
      return {
        show: false,
        // Tab选项卡默认显示页面
        activeName: 'first',

        driver_driverpoints_add:JSON.parse(localStorage.getItem('login')).driver_driverpoints_add

      };
    },
    created() {
      _this = this;
    },
    methods: {

      // 关闭方法
      closeDialog() {
        _this.show = false;
        // bus.$emit('aaa');
      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }
</style>
<style>
    .edit-driver .el-tabs__item.is-top.is-active {
    border: 0!important;
  }

</style>
